import { useFilterEmployeeAttachmentContext } from "./filter-employee-attachment.context";

export function FilterEmployeeAttachment() {
  const { dateFilterElement, reportFilterElements, clearFiltersElement } =
    useFilterEmployeeAttachmentContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {reportFilterElements}
      {clearFiltersElement}
    </div>
  );
}